(function () {
  document.querySelectorAll('.toc_link').forEach((link) => {
    link.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        const targetId = this.hash.slice(1);
        const target = document.getElementById(targetId);
        const headerHeight = document.querySelector('.header-wrapper').offsetHeight + 15;
        window.scrollTo({
          top: target.offsetTop - headerHeight,
          behavior: 'smooth',
        });
      },
      false,
    );
  });

  if ($('.rb-blog').length) {
    $('.rb-blog').on('initialized.owl.carousel', function () {
      const win_width = $(window).width();
      let item_width;
      if (window.matchMedia('(min-width: 2020px)').matches) {
        item_width = (win_width - 200) / 5 - 24;
      } else if (window.matchMedia('(min-width: 1620px)').matches) {
        item_width = (win_width - 200) / 4 - 22.5;
      } else if (window.matchMedia('(min-width: 1201px)').matches) {
        item_width = (win_width - 200) / 3 - 20;
      } else if (window.matchMedia('(min-width: 950px)').matches) {
        item_width = (win_width - 60) / 3 - 20;
      } else if (window.matchMedia('(min-width: 650px)').matches) {
        item_width = (win_width - 60) / 2 - 15;
      } else {
        item_width = win_width - 40;
      }
      $('.rb-blog .rb-blog__item').css('width', item_width);
    });
    $('.rb-blog').owlCarousel({
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 5000,
      autoplaySpeed: 700,
      autoWidth: true,
      dots: false,
      touchDrag: true,
      mouseDrag: true,
      nav: true,
      navText: ['&#xe94b', '&#xe94a'],
      responsive: {
        0: { loop: true, items: 1, margin: 20 },
        650: { loop: true, items: 2, margin: 30 },
        950: { loop: true, items: 3, margin: 30 },
      },
    });
  }

  const pageTop = [];
  pageTop.offsetDistance = 150;
  const pageTopBtn = document.getElementById('return_top');

  if (!pageTopBtn) {
    return;
  }

  const activateButton = (scroll) => {
    if (scroll > pageTop.offsetDistance) {
      pageTopBtn.classList.add('active');
    } else {
      pageTopBtn.classList.remove('active');
    }
  };

  window.onscroll = function () {
    activateButton(window.scrollY);
  };
  pageTopBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
})();
